<template>
  <v-container>
    <v-row>
      <v-col class="d-flex justify-end">
        <c-btn class="mx-1" color="blue" outlined iconName="mdi-pencil" :disabled="disabledByRole" @click="openDialog = true">수정</c-btn>
        <c-btn class="mx-1" color="blue" outlined iconName="alarm" @click="timeOpenDialog = true">운영시간변경</c-btn>
        <c-btn class="mx-1" color="grey" outlined iconName="delete" :disabled="$store.state.userInfo.role === 'SA' ? false : true" @click="onDeleteCenter">
          삭제
        </c-btn>
        <c-btn class="mx-1" color="grey" outlined @click="$router.go(-1)"
               iconName="mdi-format-list-bulleted-square">
          돌아가기
        </c-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <c-card>
          <v-row justify="space-around" align="center">
            <div style="width: calc(100% - 250px); margin-left:30px;">
              <v-row align="center">
                <v-col cols="12" class="px-0">
                  <span>[센터 정보]</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>센터명</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" class="pt-0">
                  <span class="black--text">{{ centerInfo.centerName }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>대표자 이름</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" class="pt-0">
                  <span class="black--text">{{ centerInfo.directorOfCenter }}</span>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>사업자등록번호</span>
                </v-col>
                <v-col cols="12" sm="6" md="10">
                  <span class="black--text">{{ centerInfo.registrationNumber }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>센터 주소</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-row class="ma-0 pa-0">
                    <span class="black--text"> {{ centerInfo.centerAddress }}</span>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <span class="black--text"> {{ centerInfo.centerAddressDetails }}</span>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>차고지 주소</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-row class="ma-0 pa-0">
                    <span class="black--text"> {{ centerInfo.garageAddress }}</span>
                  </v-row>
                  <v-row class="ma-0 pa-0">
                    <span class="black--text"> {{ centerInfo.garageAddressDetails }}</span>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="4" md="2">
                  <span>운영시간</span>
                </v-col>
                <v-col cols="12" sm="8" md="10">
                  <v-row>
                    <v-col cols="2"></v-col>
                    <v-col cols="5">{{ centerOperTimeList[0] ? '예약 접수 시간' : '-' }}</v-col>
                    <v-col cols="5">{{ centerOperTimeList[0] ? '차량 운행 시간' : '-' }}</v-col>
                  </v-row>
                  <v-row>
                    <template v-if="centerOperTimeList[0]" v-for="day in centerOperTimeList">
                      <v-col cols="2">
                        {{  setDayWeek(day) }}
                      </v-col>
                      <template v-if="day && day.operation === 'Enable'">
                        <v-col cols="5">
                          <span class="black--text">{{ day.startResrv }} ~ {{ day.endResrv }}</span>
                        </v-col>
                        <v-col cols="5">
                          <span class="black--text">{{ day.startDrive }} ~ {{ day.endDrive }}</span>
                        </v-col>
                      </template>
                      <template v-else-if="day && day.operation === 'Disable'">
                        <v-col cols="10">
                          <span>운영 안함</span>
                        </v-col>
                      </template>
                      <template v-else>
                        <v-col cols="10">
                          <span>-</span>
                        </v-col>
                      </template>
                    </template>
                  </v-row>
                </v-col>


                <v-col cols="12" sm="6" md="2">
                  <span>센터 전화번호</span>
                </v-col>
                <v-col cols="12" sm="6" md="10" class="pt-0">
                  <span class="black--text">{{ centerInfo.number }}</span>
                </v-col>
                <template v-if="!disabledByRole">
                  <v-col cols="12" sm="6" md="2">
                    <span>카드결제 가맹점 MID</span>
                  </v-col>
                  <v-col cols="12" sm="6" md="10">
                    <span class="black--text">{{ centerInfo.cardMemberMid }}</span>
                  </v-col>
                </template>
                <v-col cols="12" sm="6" md="2">
                  <span>문자발송</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ setEnableText(centerInfo.remindAlert) }} <span v-if="centerInfo.remindAlert == true">(출발 {{
                      centerInfo.smsSendReservationAlertBefore
                    }}분 전 고객에게 안내 문자 발송)</span></span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>예약푸시발송</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ setEnableText(centerInfo.push) }} <span
                      v-if="centerInfo.push == 'Enable'">(출발 {{ centerInfo.pushSendReservationAlertBefore }}분 전 고객에게 안내 푸시 발송)</span></span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>서비스 이용</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ setEnableText(centerInfo.status) }}</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>OBD 사용 여부</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ centerInfo.obdAvailability ? '사용' : '미사용'}}</span>
                </v-col>
                <!--<v-col cols="12" sm="6" md="2">-->
                <!--<span>결제 방식</span>-->
                <!--</v-col>-->
                <!--<v-col cols="12" sm="6" md="4">-->
                <!--<span class="black&#45;&#45;text">{{ centerInfo.centerPay.configName}}</span>-->
                <!--</v-col>-->
              </v-row>
              <v-divider></v-divider>
              <v-row align="center">
                <v-col cols="12" class="px-0">
                  <span>[센터 현황]</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>보유 기사</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ centerStatus.drivers }} 명</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>소속 관리자</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text"> {{ centerStatus.admins }} 명</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>보유 차량</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ centerStatus.vehicles }} 대</span>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>소속 직원</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ centerStatus.users }} 명</span>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <span>보유 회원</span>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <span class="black--text">{{ centerStatus.customers }} 명</span>
                </v-col>
              </v-row>
            </div>
          </v-row>
        </c-card>
      </v-col>
    </v-row>

    <center-c-u-dialog
        :open.sync="openDialog"
        :center="centerInfo"
        @reqUpdateCenter="reqUpdateCenter"
    ></center-c-u-dialog>

    <center-oper-time-c-u-dialog
        :open.sync="timeOpenDialog"
        :centerOperTimeData="clonedCenterOperTimeList"
        :center-id="centerInfo.id"
        @reqAddCenterOperTime="reqAddCenterOperTime"
        @reqUpdateCenterOperTime="reqUpdateCenterOperTime"
    ></center-oper-time-c-u-dialog>

  </v-container>
</template>

<script>
import CenterCUDialog from "./CenterCUDialog"
import CenterOperTimeCUDialog from "./CenterOperTimeCUDialog"

export default {
  components: {CenterCUDialog, CenterOperTimeCUDialog},

  data() {
    return {
      centerInfo: {
        id: '',
        centerName: '',
        directorOfCenter: '',
        centerAddress: '',
        garageAddress: '',
        registrationNumber: '',
        cardMemberMid: '',
        weekday: '',
        weekdayFirstResv: '',
        weekdayLastResv: '',
        weekdayFirstDrive: '',
        weekdayLastDrive: '',
        weekend: '',
        weekendFirstResv: '',
        weekendLastResv: '',
        weekendFirstDrive: '',
        weekendLastDrive: '',
        number: '',
        reservDoneAlert: '',
        remindAlert: '',
        reservCanceledAlert: '',
        status: '',
      },
      centerStatus: {
        drivers: '',
        admins: '',
        vehicles: '',
        users: '',
        customers: '',
      },
      param: this.$route.params.centerId,
      openDialog: false,
      timeOpenDialog: false,
      centerOperTimeList: [],
      weekdayList: [],
      weekendList: [],
    }
  },
  mounted() {
    this.reqCenterDetail()
    this.reqCenterOperTime();
  },
  computed: {
    disabledByRole() {
      return this.$store.state.userInfo.role === 'RM';
    },
    clonedCenterOperTimeList() {
      return JSON.parse(JSON.stringify(this.centerOperTimeList));
    }
  },
  methods: {
    async reqCenterDetail() {
      const res = await this.$api.getCenterManageInfoById(this.param);
      this.centerInfo = res.data.detailInfo;
      this.centerStatus = res.data;
    },
    setEnableText(text) {
      if (text === 'Enable' || text === true) {
        return '활성';
      } else if (text === 'Disable' || text === false) {
        return '비활성';
      } else {
        return '';
      }
    },
    onDeleteCenter() {
      this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "센터를 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteCenter();
            }
          });
    },
    async reqDeleteCenter() {
      try {
        const res = await this.$api.deleteCenterInfo(this.centerInfo.id);
        console.log('res', res);
        this.$store.commit('alert', {
          open: true, msg: res.data.centerName + ' 센터가 삭제되었습니다.', persistent: true,
          callBack: () => {
            this.$router.push('/center');
          }
        });
      } catch (e) {
        this.$store.commit('snackbar', {e, where: 'reqDeleteCenter'});
      }
    },
    async reqUpdateCenter(data) {
      try {
        let reqParam = {};
        reqParam = data;
        console.log('update reqParam', reqParam)
        await this.$api.updateCenterInfo(reqParam);
        const res = await this.$api.getCenterManageInfoById(this.param);
        this.centerInfo = res.data.detailInfo;
        this.openDialog = false;

        this.$store.commit('centerInfo', {
          centerId: this.centerInfo.id,
          centerName: this.centerInfo.centerName,
          garagePoint: this.centerInfo.garagePoint,
          centerPoint: this.centerInfo.centerPoint,
          weekday: this.centerInfo.weekday,
          weekdayFirstDrive: this.centerInfo.weekdayFirstDrive,
          weekdayLastDrive: this.centerInfo.weekdayLastDrive,
          weekdayFirstResv: this.centerInfo.weekdayFirstResv,
          weekdayLastResv: this.centerInfo.weekdayLastResv,
          weekend: this.centerInfo.weekend,
          weekendFirstDrive: this.centerInfo.weekendFirstDrive,
          weekendLastDrive: this.centerInfo.weekendLastDrive,
          weekendFirstResv: this.centerInfo.weekendFirstResv,
          weekendLastResv: this.centerInfo.weekendLastResv,
          useList: this.centerInfo.useList
        });

        this.$store.commit('alert', {open: true, msg: "정보가 수정되었습니다."});

      } catch (e) {
        this.$store.commit('snackbar', {e, where: 'reqUpdateCenter'});

      }
    },
    async reqCenterOperTime() {
      try {
        const res = await this.$api.getCenterOperTime(this.param);

        this.centerOperTimeList = res.data.sort((a, b) => a.dayWeek - b.dayWeek);
        // 일요일을 맨 뒤로 보내준다.
        this.centerOperTimeList.push(this.centerOperTimeList.shift());
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqCenterOperTime'});
      }
    },
    setDayWeek(day) {
      switch (day.dayWeek) {
        case 0:
          return '(일)';
        case 1:
          return '(월)';
        case 2:
          return '(화)';
        case 3:
          return '(수)';
        case 4:
          return '(목)';
        case 5:
          return '(금)';
        case 6:
          return '(토)';
      }
    },
    async reqAddCenterOperTime(data) {
      try {
        const res = await this.$api.addCenterOperTime(data);
        this.centerOperTimeList = res.data;

        this.timeOpenDialog = false;
        this.$store.commit('snackbar', {color: 'blue', msg: '등록이 완료되었습니다.'});
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqAddCenterOperTime'});
      }
    },
    async reqUpdateCenterOperTime(data) {
      try {
        const res = await this.$api.updateCenterOperTime(data);
        this.centerOperTimeList = res.data;

        this.timeOpenDialog = false;
        this.$store.commit('snackbar', {color: 'blue', msg: '수정이 완료되었습니다.'});
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqUpdateCenterOperTime'});
      }
    },
  }
}
</script>

<style scoped>

</style>
